import { Component } from '@angular/core';
import { APPCONFIG } from '../../config';
import { TranslateService } from '@ngx-translate/core';
import { HttpService } from '../../shared/services/http.service';
import { SessionHandler } from '../../shared/services/session-handler.service';
import { OktaAuthStateService, OKTA_AUTH } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { Inject } from '@angular/core';

@Component({
    selector: 'my-app-header',
    styles: [],
    template: require('./header.component.html'),
    providers: [HttpService, SessionHandler]
})
export class AppHeaderComponent {
    AppConfig: any;
    profilePicURL: string;
    private disabled: boolean = false;
    private items: Array<any> = [
        { name: 'EN', value: 'English', disabled: false },
        { name: 'IT', value: 'Italian', disabled: false },
        { name: 'DE', value: 'German', disabled: false },
        { name: 'FR', value: 'French', disabled: false },
        { name: 'PL', value: 'Polish', disabled: false },
    ];
    private item: string = 'English';

    constructor(
        public translate: TranslateService,
        private oktaAuthStateService: OktaAuthStateService,
        @Inject(OKTA_AUTH) private oktaAuth: OktaAuth
    ) {}

    changeLanguage(value: any) {
        localStorage.setItem('selectedValue', value.value);
        switch (value.value) {
            case 'English': this.translate.use('en'); break;
            case 'Italian': this.translate.use('it'); break;
            case 'German': this.translate.use('de'); break;
            case 'French': this.translate.use('fr'); break;
            case 'Polish': this.translate.use('pl'); break;
        }
    }

    getProfilePic() {
        let src = this.profilePicURL;
        if (!src) {
            src = "https://atjoin.in/images/default.png";
        }
        return src;
    }

    ngOnInit() {
        let val = localStorage.getItem('selectedValue');
        if (val != this.item) {
            this.item = val;
        }
        if (this.item == null) {
            this.item = 'English';
        }
        this.AppConfig = APPCONFIG;
        // Use Okta's authState$ for user info
        this.oktaAuthStateService.authState$.subscribe(async (authState) => {
            if (authState.isAuthenticated) {
                const userInfo = await this.oktaAuth.getUser();
                this.profilePicURL = typeof userInfo?.picture === 'string' ? userInfo.picture as string : null;
            } else {
                this.profilePicURL = null;
            }
        });
    }
}